// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeAwardGetMineBody = {};

export type typeAwardGetMineOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    thisSeason: {
      medalsEarned: number;
      medalsCustom: number;
      trophiesEarned: number;
      trophiesCustom: number;
    };
    allTime: {
      medalsEarned: number;
      medalsCustom: number;
      trophiesEarned: number;
      trophiesCustom: number;
    };
    awards: {
      awardGrantId: string;
      poolId: string;
      contestId: string | null;
      contestName: string | null;
      kind: "medal" | "trophy";
      source: "earned" | "custom";
      name: string;
      color:
        | "color1"
        | "color2"
        | "color3"
        | "color4"
        | "color5"
        | "color6"
        | "color7"
        | "color8";
      isThisSeason: boolean;
      grantedAt: string;
    }[];
  };
};

export type typeAwardGetMineOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeAwardGetMineOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeAwardGetMineOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaAwardGetMineBody = {
  type: "object",
  properties: {},
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createAwardGetMine(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaAwardGetMineBody);
  }

  return async function postAwardGetMine(
    payload: typeAwardGetMineBody,
  ): Promise<typeAwardGetMineOutput200 | typeAwardGetMineOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postAwardGetMine" failed before calling the network. #6e734a86b6e2`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#6e734a86b6e2" },
        },
        data: null,
      } as typeAwardGetMineOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/award/get-mine`,
      httpMethod: "POST",
      options,
    })) as typeAwardGetMineOutput200 | typeAwardGetMineOutput400;
  };
}
